import React, { useEffect, useState } from 'react';
import Logo from '../components/Logo';

import ProjectsSection from '../components/ProjectsSection';


const Showcase = () => {
  
  return (
    <>
      
      <Logo/>
      <ProjectsSection/>
      
      
      
    </>  
  );
}
export default Showcase;
